// Performance / Lite mode. Detects genuinely low-end devices (our core audience:
// Chromebooks and cheap laptops) and, in "auto", turns on a flattened render path
// that drops the GPU-expensive effects (frosted-glass backdrop-filter, wallpaper
// blur) and all transitions/animations, and caps the number of live tab iframes.
// The detection logic is mirrored (inlined) in the build's pre-paint script so the
// class is set before first paint - keep the two in sync.

// True on a device that will struggle with heavy compositing: Data Saver on, <=2GB
// reported memory, or <=2 logical cores. All three are conservative so a capable
// laptop is never degraded automatically; the user can still force it in Settings.
export function lowEndDevice() {
	try {
		const c = navigator.connection;
		if (c && c.saveData === true) return true;
		if (typeof navigator.deviceMemory === "number" && navigator.deviceMemory <= 2) return true;
		if (typeof navigator.hardwareConcurrency === "number" && navigator.hardwareConcurrency <= 2) return true;
	} catch (e) {}
	return false;
}

// Whether lite mode should be active for a given setting value.
export function perfActive(mode) {
	if (mode === "on") return true;
	if (mode === "off") return false;
	return lowEndDevice(); // "auto"
}

// Read the resolved state off the root (set by applyTheme / the pre-paint), so
// render code doesn't re-run detection on every frame.
export function isPerf() {
	try { return document.documentElement.dataset.perf === "on"; } catch (e) { return false; }
}
